module.exports = __webpack_public_path__ + "img/revo_5bonus.ab87abaf.png";